import{createContext}from'react';export const PageTypeContext=createContext({});